import { reportLog } from 'services/userMonitoring'

function markName(base: string, chatId: number): string {
  return `${base}_${chatId}`
}

function clearStreamMarks(chatId: number): void {
  try {
    performance.clearMarks(markName('trip_chat_stream_start', chatId))
    performance.clearMarks(markName('trip_chat_first_token', chatId))
    performance.clearMarks(markName('trip_chat_stream_complete', chatId))
  } catch { /* performance API may not be available */ }
}

export function trackStreamStart(chatId: number): void {
  try {
    performance.mark(markName('trip_chat_stream_start', chatId))
  } catch { /* performance API may not be available */ }
  reportLog('trip_chat.stream_start', { chatId }, 'info')
}

export function trackFirstToken(chatId: number): void {
  try {
    performance.mark(markName('trip_chat_first_token', chatId))
    const ttft = performance.measure(
      'trip_chat_ttft',
      markName('trip_chat_stream_start', chatId),
      markName('trip_chat_first_token', chatId),
    )
    reportLog('trip_chat.first_token', { chatId, ttftMs: Math.round(ttft.duration) }, 'info')
  } catch { /* marks may not exist */ }
}

export function trackStreamComplete(chatId: number, userStopped: boolean): void {
  try {
    performance.mark(markName('trip_chat_stream_complete', chatId))
    const duration = performance.measure(
      'trip_chat_duration',
      markName('trip_chat_stream_start', chatId),
      markName('trip_chat_stream_complete', chatId),
    )
    reportLog('trip_chat.stream_complete', { chatId, durationMs: Math.round(duration.duration), userStopped }, 'info')
  } catch { /* marks may not exist */ }
  clearStreamMarks(chatId)
}

export function trackStreamError(chatId: number | undefined, errorType: 'network' | 'unknown'): void {
  reportLog('trip_chat.stream_error', { chatId, errorType }, 'error')
  if (chatId !== undefined) {
    clearStreamMarks(chatId)
  }
}

export function trackRetry(chatId: number, attempt: number): void {
  reportLog('trip_chat.retry', { chatId, attempt }, 'info')
}
